import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=d4d14cfa&scoped=true&"
import script from "./Notes.vue?vue&type=script&lang=js&"
export * from "./Notes.vue?vue&type=script&lang=js&"
import style0 from "./Notes.vue?vue&type=style&index=0&id=d4d14cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d14cfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4d14cfa')) {
      api.createRecord('d4d14cfa', component.options)
    } else {
      api.reload('d4d14cfa', component.options)
    }
    module.hot.accept("./Notes.vue?vue&type=template&id=d4d14cfa&scoped=true&", function () {
      api.rerender('d4d14cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetailsPage/Notes.vue"
export default component.exports